import { FunctionComponent, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { Button, showErrorToast, showSuccessToast } from '@fff-web/fff-ui-shared';
import { subscribeSms } from '../../../services/mailist';
import * as styles from './TextMeUpdates.module.scss';

export const TextMeUpdates: FunctionComponent = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const handleClick = async () => {
    try {
      const response = await subscribeSms();
      if (response.success) {
        showSuccessToast('Success', 'Successfully subscribed to SMS updates!');
        setIsButtonDisabled(true);
      } else {
        throw new Error('Subscription to SMS updates failed');
      }
    } catch (err) {
      datadogLogs.logger.error('Failed subscribe to SMS updates', {}, err as Error);
      showErrorToast('Error', 'Failed subscribe to SMS updates');
    }
  };

  return (
    <div className={styles.container}>
      <h1>Get Notified About Your Order</h1>
      <Button
        onClick={handleClick}
        variation="rounded-black"
        height={62}
        disabled={isButtonDisabled}
      >
        TEXT ME UPDATES
      </Button>
      <div className={styles.disclaimer}>
        By selecting this button you are agreeing to receive messages updating the status of this
        order. You can stop receiving messages at any time by replying STOP.
      </div>
    </div>
  );
};
